import { ButtonKind } from '../Button';

export const buttonUIProps = {
  variant: 'secondary',
  kind: ButtonKind.UTILITY,
};
